import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { WidgetComponent } from 'app/modules/widget/components/widget/widget.component';
import { Dashboard } from 'app/providers/bridge-api/dashboard.service';
import { AlertService } from 'app/services/alert.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-apply-comparison-dialog',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './apply-comparison-dialog.component.html',
  styleUrls: ['./apply-comparison-dialog.component.scss'],
})
export class ApplyComparisonDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() widgetComponent: WidgetComponent;
  @Input() dashboard: Dashboard;

  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();

  comparisonsData: DropdownObject[] = [];
  selectedComparisonId;

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.comparisonsData = Object.values(this.dashboard.comparisons)
      .filter((c) => c.page === this.widgetComponent.widget.payload.page)
      .map((c) => {
        const dropdownObject = {
          id: c.id,
          title: c.title,
          disabled: !this.widgetComponent.canApplyComparison(c),
          tooltip: undefined,
        };

        if (dropdownObject.disabled) {
          dropdownObject.tooltip = {
            text: translate('apply-comparison-dialog-component.not-compatible'),
          };
        }

        return dropdownObject;
      });
    this.selectedComparisonId = this.widgetComponent.widget.payload.comparison;

    if (this.comparisonsData.length === 1 && !this.comparisonsData[0].disabled) {
      this.selectedComparisonId = this.comparisonsData[0].id;
    }
  }

  onCancel() {
    this.modalClosed.emit(null);
  }

  onSave() {
    const selectedComparison = this.dashboard.comparisons[this.selectedComparisonId];

    this.alertService.showToast(
      translate('apply-comparison-dialog-component.applied', { title: selectedComparison.title })
    );

    const data: any = {
      comparison: selectedComparison,
      widget: this.widgetComponent.widget,
    };

    if (this.widgetComponent.widget.payload.comparison) {
      data.previousComparison =
        this.dashboard.comparisons[this.widgetComponent.widget.payload.comparison];
    }

    this.modalClosed.emit(data);
  }
}
